import * as itemsAPI from "./items/itemsAPI";
import * as Files from "./KB/Files";
import * as KBAPI from "./KB/KBAPI";

// Simple wrapper class that mirrors backend OpenKBS interface
export class OpenKBS {
    constructor(KBData) {
        this.KBData = KBData;
        this.kbId = KBData?.kbId?.toString();
        this.Files = Files;
        this.itemsAPI = itemsAPI;
        this.KBAPI = KBAPI;
    }

    // Simple CRUD wrapper methods
    async createItem({itemType, itemId, body, skipEmbedding}) {
        const attributes = [
            { attrType: "itemId", attrName: "itemId", encrypted: false },
            { attrType: "body", attrName: "body", encrypted: true }
        ];

        const item = {
            itemId: itemId,
            body: typeof body === 'string' ? body : JSON.stringify(body)
        };

        return await itemsAPI.createItem({
            itemId,
            attributes,
            itemType,
            KBData: this.KBData,
            item,
            skipEmbedding
        });
    }

    async updateItem({itemId, body, itemType}) {
        const attributes = [
            { attrType: "itemId", attrName: "itemId", encrypted: false },
            { attrType: "body", attrName: "body", encrypted: true }
        ];

        const item = {
            itemId: itemId,
            body: typeof body === 'string' ? body : JSON.stringify(body)
        };

        return await itemsAPI.updateItem({
            itemId,
            attributes,
            itemType,
            KBData: this.KBData,
            item
        });
    }

    async getItem(itemId) {
        const response = await itemsAPI.getItem({
            itemId,
            KBData: this.KBData
        });

        if (response?.item?.body) {
            const decryptedBody = await itemsAPI.decrypt(response.item.body);
            try {
                response.item.body = JSON.parse(decryptedBody);
            } catch (e) {
                response.item.body = decryptedBody; // Keep as string if not JSON
            }
        }

        return response;
    }

    async deleteItem(itemId) {
        return await itemsAPI.deleteItem({
            itemId,
            KBData: this.KBData
        });
    }

    async fetchItems({limit = 1000, itemType = null, beginsWith = null, from = null, to = null, field = null, filterMeta = null} = {}) {
        const params = { limit };

        // Add from/to range parameters if provided
        if (field !== null) params.field = field;
        if (itemType !== null) params.itemType = itemType;
        if (from !== null) params.from = from;
        if (to !== null) params.to = to;
        if (beginsWith !== null) params.beginsWith = beginsWith;
        if (filterMeta !== null) params.filterMeta = filterMeta;

        const response = await itemsAPI.fetchItems(this.KBData, params);

        // Decrypt body fields in all items
        if (response?.items) {
            for (let itemWrapper of response.items) {
                if (itemWrapper?.item?.body) {
                    try {
                        const decryptedBody = await itemsAPI.decrypt(itemWrapper.item.body);
                        itemWrapper.item.body = JSON.parse(decryptedBody);
                    } catch (e) {
                        console.warn('Failed to decrypt item body:', e);
                    }
                }
            }
        }

        return response;
    }

    // Utility methods for encryption/decryption
    async encrypt(plaintext) {
        return itemsAPI.encrypt(plaintext);
    }

    async decrypt(ciphertext) {
        return itemsAPI.decrypt(ciphertext);
    }
}

// Export function to create OpenKBS instance
export const createOpenKBS = (KBData) => new OpenKBS(KBData);